import styled from 'styled-components';
import { Icon, loading } from '@web-chat-core/ui-kit';
import { WaitingControlsSection } from 'pages/WaitingApprovalPage/view';

const media = {
    tablet: '@media screen and (max-width: 800px)',
};

/** Единый вертикальный отступ: медиа → текст → кнопки */
const APPROVAL_SECTION_GAP = 20;

const APPROVAL_CROSSFADE_MS = 400;

export const LottieStage = styled.canvas.attrs({
    width: 352,
    height: 352,
})`
    display: block;
    width: 352px;
    height: 352px;
`;

export const StickerLottieWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const ApprovalStateContainer = styled.div`
    height: 352px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${APPROVAL_SECTION_GAP}px;
    width: 100%;
    max-width: 900px;
    margin: 0 auto;

    ${media.tablet} {
        flex: 1;
        min-height: 0;
        height: auto;
    }
`;

export const ApprovalMediaArea = styled.div`
    margin-top: 46px;
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    display: flex;
    align-items: center;
    justify-content: center;

    ${media.tablet} {
        flex: 1;
        min-height: 0;
    }
`;

export const ApprovalMediaInner = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

export const ApprovalCrossfadeLayer = styled.div<{ $active: boolean }>`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: ${({ $active }) => ($active ? 1 : 0)};
    transition: opacity ${APPROVAL_CROSSFADE_MS}ms ease;
    pointer-events: ${({ $active }) => ($active ? 'auto' : 'none')};
`;

export const ApprovalFooter = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${APPROVAL_SECTION_GAP}px;
    margin: 0;
    padding: 0;
    width: 100%;
`;

export const ApprovalFooterMessageSlot = styled.div`
    position: relative;
    width: 100%;
    min-height: 20px;
`;

export const ApprovalFooterActionsSlot = styled.div`
    position: relative;
    width: 100%;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

/** Без лишнего margin-top — высота слота совпадает с блоком кнопок «отклонено» */
export const ApprovalWaitingControls = styled(WaitingControlsSection)`
    margin-top: 0;
`;

export const ApprovalFooterText = styled.div`
    margin: 0;
    text-align: center;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.root.colors.basicColors['60%']};
`;

export const ApprovalFooterTextRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
`;

export const ApprovalSpinnerIcon = styled(Icon)`
    flex-shrink: 0;
    ${loading};
`;

export const ApprovalFooterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${APPROVAL_SECTION_GAP}px;
    margin: 0;
    padding: 0;
`;

export const ApprovalRetryButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
    letter-spacing: 0.25px;
    color: ${(props) => props.theme.root.colors.accent.textOrIcon};
`;
